import axios from 'axios';
import type { CreateEntityFormData } from '../create-entity/types/create-entity-form-data';
import { SignupErrorKey } from '../verify-user/types/enums/signup-error-key';

export default class CreateEntityService {
  static async createEntity(formData: CreateEntityFormData): Promise<string> {
    const body = new FormData();
    body.append('entity-name', formData.name);
    body.append('entity-country-code', formData.countryCode);
    body.append('entity-datacenter', formData.datacenter.toString());
    body.append('entity-timezone', formData.timezone);
    body.append('signup-version', '2');
    const { request, data } = await axios.post(`/signup/v2/create-entity`, body);
    if (data.error) {
      throw new Error(data.error);
    }
    if (!request.responseURL) {
      throw new Error(SignupErrorKey.NoResponseUrl);
    }
    return request.responseURL;
  }
}
